/**
 * The banner's "already dismissed this session" flag, and the inline script
 * that acts on it before first paint.
 *
 * Kept out of `index.tsx` because that file is `"use client"` and the script
 * has to be rendered by a *server* component — see `HideDismissedBannerScript`
 * below for why.
 */
export const STORAGE_KEY = "headerBannerClosed";

/**
 * Hides a previously-dismissed banner before the browser paints.
 *
 * The banner renders in the server HTML (see `isVisible` in `index.tsx`), which
 * is what stops it shifting the whole page down after hydration. But a supporter
 * who already dismissed it this session would then see it flash and vanish — the
 * same shift, just rarer. `sessionStorage` cannot be read on the server, so this
 * runs inline during parse and sets an attribute CSS keys off, before anything
 * is painted. React state catches up in the banner's effect.
 */
export const HIDE_IF_DISMISSED = `(function(){try{if(sessionStorage.getItem(${JSON.stringify(STORAGE_KEY)})){document.documentElement.setAttribute("data-banner-closed","true")}}catch(e){}})()`;
